import { createFileRoute } from "@tanstack/react-router";
import CompanySettingsForm from "@/components/company_admin/company_settings/CompanySettingsForm";
import { useRouterStore } from "@/store/zustandStore";
import { companyAdminsOptions } from "@/api";

export const Route = createFileRoute("/_portal/company/$companyId/settings")({
  component: CompanySettings,
  loader: ({ params }) => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(companyAdminsOptions(params.companyId));
  },
});

function CompanySettings() {
  const { companyId } = Route.useParams();
  return <CompanySettingsForm companyId={companyId} />;
}
